import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import onClickOutside from 'react-onclickoutside';
import { translate } from 'react-i18next';


import { logoutButtonClick } from '../../Auth/actions';
import { toggleSettingsModal, switchCurrentDevice } from '../../Modal/actions';
import { formatNumber } from '../../../utils/helpers';

@translate(['header'], { wait: true })
@onClickOutside
class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settingsOpened: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  render() {
    const { currentDevice, devices, t } = this.props;
    return (
      <li className={cx('has-submenu', { active: this.state.settingsOpened })}>
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.setState({
              settingsOpened: !this.state.settingsOpened,
            });
          }}
        ><span className="icon icon-settings" /></a>
        <div className="header__nav__submenu">
          <div className="header__scroll__holder">
            <div className="header__nav__submenu__item">
              <div className="header__nav__submenu__item__settings">
                <div className="holder">
                  <div className="title">{this.props.profile.name}</div>
                  <div className="header__nav__submenu__item__settings_link">
                    <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({
                          settingsOpened: false,
                        });
                        this.props.toggleModal('profile');
                      }}
                    >{t('header:personal')}</a>
                  </div>
                  <div className="header__nav__submenu__item__settings_link">
                    <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.logout();
                      }}
                    >{t('header:logout')}</a>
                  </div>
                </div>
              </div>
            </div>
            {
              devices.length ?
              devices.map((device, i) => (
                <div key={device.id} className="header__nav__submenu__item">
                  <div className="header__nav__submenu__item__settings" style={devices.length - 1 === i ? { borderBottom: 'none' } : null}>
                    <div className="holder">
                      <div className="title">{device.name}</div>
                      <div className="header__nav__submenu__item__settings_code">
                        <div className="name">
                          {formatNumber(device.packageId, 6)}
                        </div>
                        <div className="status status-active">{t('header:activated')}</div>
                      </div>
                      <div className="header__nav__submenu__item__settings_link">
                        <a
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                              settingsOpened: false,
                            });
                            this.props.handleDeviceClick(device);
                            this.props.toggleModal('vehicles');
                          }}
                        >{t('header:settings')}</a>
                      </div>
                    </div>
                  </div>
                </div>
                )) : null
            }
          </div>
        </div>
      </li>
    );
  }

  handleClickOutside() {
    this.setState({
      settingsOpened: false,
    });
  }
}

Settings.propTypes = {
  devices: PropTypes.array,
  profile: PropTypes.object,
  vehicles: PropTypes.array,
  contract: PropTypes.object,
  logout: PropTypes.func,
  toggleModal: PropTypes.func,
  handleDeviceClick: PropTypes.func,
};

export default connect(
  state => ({
    devices: state.devices.devices,
    profile: state.auth.profile,
    vehicles: state.settings.vehicles,
    currentDevice: state.devices.currentDevice,
  }),
  dispatch => ({
    logout() {
      return dispatch(logoutButtonClick());
    },
    toggleModal(type) {
      dispatch(toggleSettingsModal({ type }));
    },
    handleDeviceClick(device) {
      dispatch(switchCurrentDevice({ device }));
    },
  }),
)(Settings);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderRightNav/Settings.js